import { UserSettingsActionKind } from './userSettingsActionKind';
export const userSettingsReducer = (state, action) => {
    switch (action.type) {
        case UserSettingsActionKind.UpdateHolidayYear: {
            return {
                ...state,
                ...action.payload,
                start: new Date(action.payload.start),
                end: new Date(action.payload.end),
                entitlementSetOn: action.payload.entitlementSetOn ?? new Date(),
                initialHolidayDataLoaded: true,
            };
        }
        case UserSettingsActionKind.UpdateUser: {
            return {
                ...state,
                ...action.payload,
                initialSetupDoneAt: new Date(action.payload.initialSetupDoneAt),
                initialUserDataLoaded: true,
            };
        }
        case UserSettingsActionKind.RefreshUserData: {
            return {
                ...state,
                refresh: state.refresh + 1,
            };
        }
        default: {
            return state;
        }
    }
};
